/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DashboardServiceabilityAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the serviceability view.
 */
define([], () => {
	class InAppSlideoutDOMAPI {

		/**
		 * @function InAppSlideoutDOMAPI#render
		 * @description render the InAppSlideout view
		 * @return {Promise} Promise resolved when the view is rendered
		 */
		render() {}

		/**
		 * @function InAppSlideoutDOMAPI#registerView
		 * @description Register slideout contribution
		 * @param {string} id - contribution id
		 * @param {object} instance - contribution instance
		 */
		registerView() {}

		/**
		 * @function InAppSlideoutDOMAPI#removeView
		 * @description remove a slideout contribution
		 * @param {string} id - id of contribution to remove
		 */
		removeView() {}

		/**
		 * @function InAppSlideoutDOMAPI#getViews
		 * @description get the list of contributions
		 * @return {Object[]} list of contributions
		 */
		getViews() {}

		/**
		 * @function InAppSlideoutDOMAPI#getView
		 * @description get a single contribution by id
		 * @param {string} id - id of the contribution
		 * @return {Object} contribution object
		 */
		getView() {}

		/**
		 * @function InAppSlideoutDOMAPI#onDomStateChange
		 * @description register a on state change callback, to be called when the DOM state is changed such as mounted or unmounted
		 * @param {Function} fn - function to be called when the DOM state changes such as mounted or unmounted
		 * @return {Function} function returned to destroy remove the listener
		 */
		onDomStateChange () {}
	}

	return InAppSlideoutDOMAPI;
});
